<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/twabJ8/image/James-King-and-Raven-lowres.jpg?1733067604718" alt="This image is the cover for the book King and Raven"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">King and Raven
      </h1>
      <p class="bookDescription body article font2">
        <p>Raven (a.k.a. Micah of Greenfarm), the young son of a poor tenant farmer, lives just outside of Camelot. Like other poor farmers, he has no interaction with the reigning monarch, the great King Arthur, but his station means nothing to him when some of King Arthur’s knights rape and murder his sister. Raven swears an oath that transcends social station and nobility; he vows to avenge. Becoming a member of the royal household, Raven manages to get closer and closer to his targets. Cary James’s novel is full of adventure, intrigue, passion, hatred, and questioned loyalty.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Cary James
      </h2>
      
      <p class="authorDescription body article">Cary James was born in Virginia, and received degrees from the College of William and Mary and the University of California at Berkeley. For two decades he practiced architecture in the San Francisco Bay area, before becoming a professional writer. He has published short stories, poems and book reviews, and served as chair of the Fiction Award Committee of the Bay Area Book Reviewers Association. He is the author of Frank Lloyd Wright&rsquo;s Imperial Hotel, a photographic essay on that now-demolished building; Julia Morgan, a young person&rsquo;s biography of the San Francisco architect; and King &amp; Raven, his first novel. Baranaby Conrad once defined the full life as one in which &ldquo;you build a house, plant a tree, create a child, and fight a bull.&rdquo; James regrets that he has not yet met his bull. He lives in Mill Valley California with his wife Elaine.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?db9f1846